import { z } from 'zod';
import { TenantIdSchema, EmailSchema, PhoneSchema } from './_primitives.js';

export const CUSTOMER_STATUS = Object.freeze({
  ACTIVE:    'active',
  INACTIVE:  'inactive',
  PROSPECT:  'prospect',
  CHURNED:   'churned',
});

export const CustomerStatusEnum = z.enum(Object.values(CUSTOMER_STATUS));

export const CustomerSchema = z.object({
  tenantId:    TenantIdSchema,
  id:          z.string().optional(),
  name:        z.string().min(1),
  status:      CustomerStatusEnum.optional(),
  email:       EmailSchema.optional(),
  phone:       PhoneSchema.optional(),
  address:     z.string().optional(),
  city:        z.string().optional(),
  state:       z.string().optional(),
  zip:         z.string().optional(),
  country:     z.string().optional(),
  industry:    z.string().optional(),
  annualRevenue: z.number().nonnegative().optional(),
  creditLimit:   z.number().nonnegative().optional(),
  paymentTerms:  z.string().optional(),
  accountManager: z.string().optional(),
  isDeleted:   z.boolean().optional(),
  createdAt:   z.union([z.string(), z.object({})]).optional(),
  updatedAt:   z.union([z.string(), z.object({})]).optional(),
  version:     z.number().int().optional(),
}).passthrough();

/** @typedef {import('zod').infer<typeof CustomerSchema>} Customer */
